const COMBINING_DIACRITICAL_MARKS_PATTERN = /[̀-ͯ]/gu;

export function normalizeStoreAliasInput(storeAlias?: string): string {
  return (
    storeAlias
      ?.normalize("NFD")
      .replace(COMBINING_DIACRITICAL_MARKS_PATTERN, "")
      .toLowerCase()
      .trim()
      .replace(/&/gu, "-e-")
      .replace(/[^a-z0-9\s-]/gu, "")
      .replace(/\s+/gu, "-")
      .replace(/-+/gu, "-")
      .replace(/^-+/gu, "") || ""
  );
}

export function normalizeStoreAlias(storeAlias?: string): string {
  return (
    storeAlias
      ?.normalize("NFD")
      .replace(COMBINING_DIACRITICAL_MARKS_PATTERN, "")
      .toLowerCase()
      .trim()
      .replace(/&/gu, "-e-")
      .replace(/[^a-z0-9\s-]/gu, "")
      .replace(/\s+/gu, "-")
      .replace(/-+/gu, "-")
      .replace(/^-|-$/gu, "") || ""
  );
}
